import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { defaultLogo } from '../../env';
import { KPIIcon, CourseIcon, DashBoardIcon, MyDashBoardIcon, SupportIcon, MyCertificateIcon, PassingCriteriaIcon, ReportsIcon, ConfigIcon } from '../../SvgIconsData'
import ProPopup from './ProPopup';
import { CrownIcon } from '../../assets/icons/iconshere';
import SimulanisIcon from '../../assets/images/favicon.png'
import DownloadLauncher from '../pages/launcher/DownloadLauncher';
// import { PiChartLineUp } from 'react-icons/pi'

const Sidebar = ({ sideBar }) => {

  let location = useLocation();
  let navigate = useNavigate();
  const userData = useSelector(state => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [showLauncher, setShowLauncher] = useState(false);
  const [launchHome, setLaunchHome] = useState(false)
  const [activeTab, setActiveTab] = useState('dashboard');
  const [permissions, setPermissions] = useState([]);
  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);
  let MODE = configData.config.MODE;
  useEffect(() => {
    if (userData?.user?.permissions?.length > 0) {
      setPermissions([...userData.user.permissions])
    }
    if(userData?.plans?.data){
      setUserPlan(userData.plans.data);
    }
  }, [userData, userData.plans]);


  useEffect(() => {
    var path = location.pathname;
    var active = 'dashboard';
    if (path.startsWith('/dashboard')) active = 'dashboard';
    else if (path.startsWith('/team-dashboard')) active = 'team-dashboard';
    else if (path.startsWith('/2d/lms/dashboard')) active = 'dashboardLMS';
    else if (path.startsWith('/2d/lms/team-dashboard')) active = 'teamDashboardLMS';
    else if (path.startsWith('/2d/lms/team/user/')) active = 'teamDashboardLMS';
    else if (path.startsWith('/team/user')) active = 'team-dashboard';
    else if (path.startsWith('/total-trainings')) active = MODE === "XR" ? 'team-dashboard' : 'teamDashboardLMS';
    else if (path.startsWith('/courses')) active = 'courses';
    else if (path.startsWith('/module')) active = 'courses';
    else if (path.startsWith('/support')) active = 'support';
    else if (path.startsWith('/set/passing/criteria')) active = 'configuration';
    else if (path.startsWith('/quiz')) active = 'courses';
    else if (path.startsWith('/sop')) active = 'courses';
    else if (path.startsWith('/kpi')) active = 'kpi';
    else if (path.startsWith('/certificates')) active = 'certificates';
    else if (path.startsWith('/explore')) active = 'explore';
    else if (path.startsWith('/reports')) active = 'reports';
    else if (path.startsWith('/update/configuration/')) active = 'configuration';
    

    setActiveTab(active);
  }, [location.pathname]);


  const handleClick = (path , state) => {
    return navigate(path , state);
  }

  const LauncherDownload = () => {
    setShowLauncher(true);
    setLaunchHome(true)
  };

  return (
    <>
   {MODE === "XR" ?
        <Helmet>
           <title> XR Content Library </title>
        </Helmet>
      :
    MODE === "2D" ?
        <Helmet>
           <title> Skill Stream </title>
        </Helmet>
        :
        null
      }
    <div className='mainside'>
      <div className={sideBar ? 'sidmenu active' : 'sidmenu'}>
        <div className='mainsidelist'>
          <ul>

            {((MODE === "XR" && permissions.includes("XR.DASHBOARD.OWN")) || (MODE === "2D" && permissions.includes("SKILL.STREAM.DASHBOARD.OWN"))) && (
              <li
                onClick={() =>handleClick(MODE === "XR" ? `/dashboard/${userData.user.uuid}` : `/2d/lms/dashboard/${userData.user.uuid}`, { state: userData.user })}
                className={`${activeTab === (MODE === "XR" ? "dashboard" : "dashboardLMS") ? "active" : ""}`}
              >
              <MyDashBoardIcon /><p className="ms-3">My Dashboard</p>
              </li>
            )}


          {((MODE === "XR" && permissions.includes("XR.DASHBOARD.TEAM")) || (MODE === "2D" && permissions.includes("SKILL.STREAM.DASHBOARD.TEAM"))) &&
            <>
              {(userPlan && userPlan.teamDashboard && userPlan.teamDashboard.access) ?
                <li  onClick={() => handleClick( MODE === "XR"  ? `/team-dashboard/${userData.user.group.uuid}` : `/2d/lms/team-dashboard/${userData.user.group.uuid}`,  { state: userData.user.group } ) }
                  className={`${ activeTab === (MODE === "XR" ? "team-dashboard" : "teamDashboardLMS") ? "active" : "" }`}
                >
                  <DashBoardIcon />
                  <p className="ms-3">Team Dashboard</p>
                </li>
              : 
                <li
                  onClick={() => setOpenPro(true)}
                  className={`${
                    activeTab === "team-dashboard" ? "active pro" : "pro"
                  }`}
                >
                  <span>
                    <ReportsIcon />
                    <p className="ms-3">Team Dashboard</p>
                  </span>
                  <span>
                    <CrownIcon />
                  </span>
                </li>
              }
            </>
          }

          {((MODE === "XR" && permissions.includes("XR.DASHBOARD.COURSES")) || (MODE === "2D" && permissions.includes("SKILL.STREAM.COURSES"))) &&
                <>
                  <li onClick={() => handleClick('/courses')} className={`${activeTab == 'courses' ? 'active' : ''}`}>
                    <CourseIcon /> <p className='ms-3'> Courses </p>
                  </li>
                </>
          }

          {((MODE === "XR" && permissions.includes("XR.CERTIFICATES.LIST")) || (MODE === "2D" && permissions.includes("SKILL.STREAM.CERTIFICATES.LIST"))) &&
                <>
                {(userPlan && userPlan.myCertificate && userPlan.myCertificate.access) ?
                    <li onClick={() => handleClick(`/certificates/${userData.user.uuid}`, { state: { user: userData.user } })} className={`${activeTab == 'certificates' ? 'active' : ''}`}>
                          <MyCertificateIcon />
                          <p className='ms-3'>My Certificates</p> 
                    </li>
                    :
                    <li onClick={() => setOpenPro(true)} className={`${activeTab == 'certificates' ? 'active pro' : 'pro'}`}>
                    <MyCertificateIcon />
                    <p className='ms-3'>My Certificates</p>  <span><CrownIcon  /></span>
                  </li>}
                  </>
            }
              
           {MODE == "XR" && permissions.includes("XR.DASHBOARD.ANALYTICS") && 
            <>
             {(userPlan && userPlan.report && userPlan.report.access )?
               <li onClick={() => handleClick(`reports/${userData.user.group.uuid}`)} className={`${activeTab == 'reports' ? 'active' : ''}`}>
                <ReportsIcon />
                <p className='ms-3'>Reports</p>
                </li> 
                  :
               <li onClick={()=>setOpenPro(true)}  className={`${activeTab == 'reports ' ? 'active pro' : ' pro '}`}>
                <span> <ReportsIcon /> <p className='ms-3'>Reports</p> </span> <span><CrownIcon  /></span>
               </li>
              }
              </>
            }


           {(MODE == "XR" && permissions.includes("XR.DASHBOARD.KPI")) &&
                <>
                  {(userPlan && userPlan.kpi && userPlan.kpi.access) ?
                    <li onClick={() => handleClick('/kpi')} className={`${activeTab == 'kpi' ? 'active' : ''}`}>
                      <KPIIcon /><p className='ms-3'>KPIs</p>
                    </li>
                    :
                    <li title="upgrade plan to access kpi" onClick={()=>setOpenPro(true)} className={`${activeTab == 'kpi' ? 'active pro' : 'pro'}`}>
                    <span>  <KPIIcon /><p className='ms-3'>KPIs </p>  </span>  <span><CrownIcon  /></span>
                    </li>}
                </>
            }
{/* 
            {((MODE === "XR" && permissions.includes("XR.CONFIGURATION"))|| (MODE === "2D" && permissions.includes("XR.CONFIGURATION"))) &&
                <>
                    {(userPlan && userPlan.certificateConfig && userPlan.certificateConfig.access) ?
                      <li onClick={() => handleClick(`/update/configuration/${userData.user.uuid}`)} className={`${activeTab == 'configuration' ? 'active' : ''}`}>
                          <ConfigIcon/> <p className='ms-3'>Configurations</p>
                      </li>
                    :
                    <li title="upgrade plan to access kpi" onClick={()=>setOpenPro(true)} className={`${activeTab == 'kpi' ? 'active pro' : 'pro'}`}>
                         <span> <ConfigIcon/> <p className='ms-3'>Configurations</p>  </span>  <span><CrownIcon  /></span>
                    </li>}
                </>
            } */}
            
            {/* <li onClick={() => handleClick('/support')} className={`${activeTab == 'support' ? 'active' : ''}`}>
                <SupportIcon /><p className='ms-3'>Support</p>
            </li> */}

          </ul>
        </div>

      {/* { MODE === "XR" &&
        <div className='d-flex align-items-center justify-content-start flex-column'>
            <button className='download-meta' onClick={LauncherDownload} >
                <img src={configData.config.logo}
                    onError={(e) => {
                        e.target.src = defaultLogo;
                        e.onerror = null;
                    }}
                    referrerPolicy={'no-referrer'}
                    alt=''
                />
                <span>
                    <h6>Learn Launcher</h6>
                    <p>Download Now</p>
                </span>
            </button>
             <p className='pwrdby'> Powered by <strong>
                        <img src={SimulanisIcon}/>
                       <span>Simulanis </span>
                        </strong> </p>
        </div> } */}

      </div>
    </div>


    <ProPopup openPro={openPro} setOpenPro={setOpenPro} />          
    <DownloadLauncher show={showLauncher} handleClose={setShowLauncher} launchHome={launchHome} setLaunchHome={setLaunchHome} />                 

    </>
  )
}

export default Sidebar